var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVieuniteLogoProLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "182px",
    viewBox: "0 0 466.5 220.2",
    style: {},
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0fk{fill:#0E477A;}\r\n\t.st1fk{fill:#0E477A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0fk",
    points: "79.8,113.2 57.1,54.5 71.4,54.5 87.6,99.6 103.8,54.5 118.1,54.5 95.4,113.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M122.1,59.4c0-3.7,3-6.5,6.7-6.5c3.7,0,6.7,2.9,6.7,6.5c0,3.7-3,6.7-6.7,6.7 C125.2,66.1,122.1,63.2,122.1,59.4 M123.2,70.7h11.2v42.4h-11.2V70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M142.7,91.9c0-12.3,9.1-22.3,22-22.3C177.4,69.6,186,79,186,93v2.5h-31.6c0.8,5.4,5,9.8,12.2,9.8 c3.7,0,8.6-1.6,11.3-4.3l4.9,7.2c-4.3,3.9-11,5.9-17.5,5.9C152.6,114.2,142.7,105.5,142.7,91.9 M164.8,78.5 c-6.9,0-9.9,5.2-10.4,9.4h20.9C175,83.8,172.1,78.5,164.8,78.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M222.7,113.2v-5.4c-2.9,3.3-8.1,6.4-15,6.4c-9.3,0-13.7-5.2-13.7-13.3V70.7h11.2v25.8c0,5.9,3,7.8,7.8,7.8 c4.3,0,7.7-2.4,9.7-4.8V70.9h11.2v42.4L222.7,113.2L222.7,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M273.7,113.2V87.5c0-5.9-3-7.9-7.8-7.9c-4.4,0-7.8,2.5-9.7,5v28.6H245V70.7h11.2v5.5 c2.8-3.3,7.9-6.5,14.9-6.5c9.3,0,13.8,5.3,13.8,13.6v30L273.7,113.2L273.7,113.2L273.7,113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M294.7,59.4c0-3.7,3-6.5,6.7-6.5s6.7,2.9,6.7,6.5c0,3.7-3,6.7-6.7,6.7C297.8,66.1,294.7,63.2,294.7,59.4  M295.8,70.7H307v42.4h-11.2V70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M320.2,102.6V80.4h-7v-9.7h7V59.2h11.2v11.6h8.6v9.7h-8.6v19.1c0,2.6,1.4,4.7,3.9,4.7c1.6,0,3.3-0.6,3.9-1.3 l2.4,8.4c-1.6,1.5-4.7,2.8-9.3,2.8C324.5,114.2,320.2,110.1,320.2,102.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M345,91.9c0-12.3,9.1-22.3,22-22.3c12.7,0,21.3,9.4,21.3,23.4v2.5h-31.6c0.8,5.4,5,9.8,12.2,9.8 c3.7,0,8.6-1.6,11.3-4.3l4.9,7.2c-4.3,3.9-11,5.9-17.5,5.9C354.8,114.2,345,105.5,345,91.9 M367.1,78.5c-6.9,0-9.9,5.2-10.4,9.4 h20.9C377.3,83.8,374.4,78.5,367.1,78.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M395,107c0-3.9,3.3-7.2,7.2-7.2c3.9,0,7.2,3.3,7.2,7.2c0,3.9-3.3,7.2-7.2,7.2C398.3,114.2,395,110.9,395,107"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1fk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M265.6,166.5l9.6-43.4h15.2c6.8,0,11.4,5.1,11.4,10.9c0,6.7-4.6,14.5-16.1,14.5h-12.4l-4,18H265.6z  M286.1,145.1c7.8,0,11.7-5.1,11.7-10.9c0-4.1-3.4-7.8-8-7.8h-11.7l-4.1,18.6H286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M328.5,166.5l-8.2-18h-9.8l-4,18h-3.7l9.6-43.4h14.9c5.9,0,11.8,4,11.8,10.9c0,8.1-5.9,14.1-14.8,14.4 l8.5,18.1H328.5z M323.3,145.1c7.6,0,11.7-5.1,11.7-10.9c0-4.6-4-7.8-8.2-7.8h-11.5l-4.1,18.7H323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0fk",
    d: "M368,122.4c10.7,0,19.5,6.7,19.5,18.8c0,14.7-10.8,26.1-24,26.1c-10.8,0-19.5-6.7-19.5-18.8 C343.9,133.8,354.7,122.4,368,122.4z M367.7,125.7c-10.6,0-19.7,9.4-19.7,22.6c0,10.2,7.1,15.6,15.7,15.6 c10.5,0,19.8-9.4,19.8-22.6C383.4,131.1,376.3,125.7,367.7,125.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVieuniteLogoProLogo);
export default __webpack_public_path__ + "static/media/Vieunite_logo_Pro_Logo.a95bdbe417cfcec743e2278c1c261598.svg";
export { ForwardRef as ReactComponent };